'use client';

import dynamic from 'next/dynamic';
import type { ComponentProps } from 'react';
import type { SmartFormBlock } from '@/components/forms/SmartFormBlock/SmartFormBlock';

type SmartFormBlockProps = ComponentProps<typeof SmartFormBlock>;

const HeavyForm = dynamic(
  () =>
    import('@/components/forms/SmartFormBlock/SmartFormBlock').then((m) => ({
      default: m.SmartFormBlock,
    })),
  { ssr: false },
);

export function LazySmartFormModal(props: SmartFormBlockProps) {
  return <HeavyForm {...(props as any)} />;
}
